module.exports = __webpack_public_path__ + "img/98.cf248694.jpg";